<template>
  <HiDialog v-model="isOpen" @submit="submit" title="Select Labels">
    <div class="pt-8">
      <div class="ui-text">
        Selected Labels:
        <span v-if="selectedCount === 0"
          >No label selected. Please select from below...</span
        >
      </div>
      <div class="label-container">
        <!-- <v-btn x-small text @click="deleteRow(index)" class="mr-2">Primary</v-btn> -->
        <span
          v-for="(color, key) in selected"
          :key="key"
          :style="{ color: color[0], backgroundColor: color[1] }"
          class="label hand"
          @click="unselect(key)"
          >{{ key }}</span
        >
      </div>
      <v-divider></v-divider>
      <div>
        <!-- <v-btn x-small text @click="deleteRow(index)" class="mr-2">Primary</v-btn> -->
        <div class="ui-text">Select Labels Below:</div>
        <div>
          <span
            v-for="(color, key) in pool"
            :key="key"
            :style="{ color: color[0], backgroundColor: color[1] }"
            class="label hand"
            @click="select(key)"
            >{{ key }}</span
          >
        </div>
      </div>
      <span v-if="poolCount === 0" class="ui-text">No More Labels...</span>
      <v-divider></v-divider>
      <div class="py-3">
        <v-btn text x-small v-if="!addingNew" @click="addNew">Add New</v-btn>
        <div v-if="addingNew">
          <div class="flex-row-base pb-3">
            <span
              ref="newLabel"
              contenteditable
              spellcheck="false"
              style="min-width:30px;"
              :style="{ backgroundColor: newBgColor, color: newColor }"
              class="label"
            ></span>
            <v-spacer></v-spacer>
            <v-btn text x-small @click="addingNew = false">CANCEL</v-btn>
            <v-btn text x-small @click="submitNewLabel">OK</v-btn>
          </div>
          <div class="flex-row" style="justify-content: space-between">
            <HiColorSwatch
              width="48%"
              title="Text Colour"
              @select="color => (newColor = color)"
            ></HiColorSwatch>
            <HiColorSwatch
              width="48%"
              title="Background Colour"
              @select="color => (newBgColor = color)"
            ></HiColorSwatch>
          </div>
        </div>

        <div class="error-block" v-if="error">{{ error }}</div>
      </div>
    </div>
    <v-divider></v-divider>
  </HiDialog>
</template>

<script>
import HiDialog from "../HiDialog";
import HiColorSwatch from "../HiColorSwatch";
import { docs, updaters, collections } from "@/db";
export default {
  components: {
    HiDialog,
    HiColorSwatch
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      values: null,
      isOpen: false,
      addingNew: false,
      newColor: "#666666",
      newBgColor: "#dddddd",
      selected: {},
      pool: {},
      labelsDoc: {},
      leadDoc: {},

      error: null
    };
  },
  firestore() {
    return {
      labelsDoc: docs.labels.leads,
      leadDoc: collections.leads.doc(this.id)
    };
  },
  methods: {
    async open() {
      this.isOpen = true;
      this.error = null;
      const labels = this.leadDoc.labels;
      this.pool = Object.assign({}, this.labelsDoc);
      if (!labels || !labels.length) this.selected = {};
      else {
        labels.forEach(l => {
          this.selected[l] = this.pool[l];
          delete this.pool[l];
        });
      }
      this.$forceUpdate();
    },
    select(label) {
      this.$set(this.selected, label, this.pool[label]);
      this.$delete(this.pool, label);
    },
    unselect(label) {
      this.$set(this.pool, label, this.selected[label]);
      this.$delete(this.selected, label);
    },
    focus() {
      setTimeout(() => this.$refs.newLabel.focus(), 100);
    },
    addNew() {
      this.addingNew = true;
      this.focus();
    },

    isSelected(label) {
      this.value.forEach(l => {
        if (l === label) return true;
      });
      return false;
    },

    async submit() {
      const values = Object.keys(this.selected);
      await updaters.lead(this.id, "labels", values);
      this.isOpen = false;
    },
    async submitNewLabel() {
      const div = this.$refs.newLabel;
      const label = div.innerText.trim().toUpperCase();
      const color = [this.newColor, this.newBgColor];
      for (let l in this.labelsDoc) {
        if (label === l) {
          this.error = "Label '" + l + "' already exists!";
          return;
        }
      }

      this.error = null;
      try {
        await updaters.labels.leads(label, color);
      } catch (e) {
        this.error = e.error;
      }
      this.addingNew = false;
      this.$set(this.selected, label, color);
    }
  },
  computed: {
    selectedCount() {
      return Object.keys(this.selected).length;
    },
    poolCount() {
      return Object.keys(this.pool).length;
    }
  }
};
</script>

<style scoped>
div:focus {
  outline: none;
}
/*.color {*/
/*  width: 14px;*/
/*  height: 14px;*/
/*  display: inline-block;*/
/*  cursor: pointer;*/
/*  margin: 1px;*/
/*}*/
/*.color-container {*/
/*  border: 1px solid #aaaaaa;*/
/*  display: flex;*/
/*  flex-wrap: wrap;*/
/*  justify-content: space-evenly;*/
/*}*/

/* .label {
  margin-left: 5px;
}
.label:first-child {
  margin-left: 0px;
} */
</style>
